import React from "react";
import { authenticatedPutFetch, authenticatedDeleteFetch } from "../../../utils/AuthenticatedFetch";
import { Trans } from "react-i18next";
import i18n from '../../../i18n';

import {
  Alert,
  Dialog,
  Classes,
  Button,
  H4,
  HTMLSelect,
  InputGroup,
  FormGroup,
  H5,
  Intent,
  Checkbox,
  RadioGroup, Radio
} from "@blueprintjs/core";
import EventSelect from "../../Structure/EventSelector";

export default class EventCounterEditor extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      id: props.data.info.id,
      events: props.data.info.eventId !== undefined ? props.data.info.eventId : [],
      ratioEvents: props.data.info.ratioEvents !== undefined ? props.data.info.ratioEvents : [],
      isRatio: (props.data.info.ratioEvents !== undefined && props.data.info.ratioEvents !== []),
      level: props.data.info.level,
      title: props.data.info.title,
      success: false,
      error: false
    };
  }

  render() {
    return (
      <div>
        <Dialog
          isOpen={this.props.open}
          style={{ transition: 'none' }}
          onClose={() => this.props.onClose()}
          onOpening={() => this.setState({
            id: this.props.data.info.id,
            events: this.props.data.info.eventId,
            level: this.props.data.info.level,
            title: this.props.data.info.title,
            ratioEvents: this.props.data.info.ratioEvents,
            ratioType: (this.props.data.info.ratioEvents !== undefined && this.props.data.info.ratioEvents !== []) ? 2 : 0,
            isRatio: (this.props.data.info.ratioEvents !== undefined && this.props.data.info.ratioEvents !== []),
            success: false,
            error: false
          })}
        >
          <div className={Classes.DIALOG_BODY}>
            <H4><Trans>edit key value</Trans></H4>
            <div>
              <FormGroup
                label={<Trans>title:</Trans>}
                labelFor="title"
              >
                <InputGroup
                  type="text"
                  id="title"
                  value={this.state.title}
                  onChange={(ti) => { this.setState({ title: ti.target.value }); }}
                />
              </FormGroup>
              <HTMLSelect
                value={this.state.level}
                options={[
                  { label: i18n.t("success"), value: 0 },
                  { label: i18n.t("info"), value: 1 },
                  { label: i18n.t("warning"), value: 2 },
                  { label: i18n.t("error"), value: 3 }
                ]}
                onChange={(s) => this.setState({ level: s.target.value })}
              />

              <H5><Trans>monitored events</Trans></H5>
              <div className="flexbox-left">
                <EventSelect value={this.state.events} onSelectionChange={(selection) => this.setState({ events: selection })} />
              </div>
            </div>

            <Checkbox
              icon="percentage"
              checked={this.state.isRatio}
              label={i18n.t("is ratio")}
              onChange={(cb) => {
                this.setState({ isRatio: cb.target.checked });
                if (!cb.target.checked)
                  this.setState({ ratioEvents: [] });
              }}
            />
            {this.state.isRatio ?
              <div>
                <RadioGroup
                  label={i18n.t("of:")}
                  onChange={(rad) => {
                    switch (rad.target.value) {
                      case "0":
                        this.setState({ ratioType: rad.target.value, ratioEvents: [1, 21, 29, 31, 60, 61, 62, 110, 135, 136, 161, 180, 189, 190, 205, 223, 229, 238, 268, 320, 331, 334, 361, 368, 374, 378, 540, 580, 593] });
                        break;
                      case "1":
                        this.setState({ ratioType: rad.target.value, ratioEvents: [2, 3, 26, 30, 32, 68, 69, 76, 77, 78, 111, 137, 138, 162, 181, 191, 206, 215, 217, 224, 225, 321, 230, 239, 260, 266, 267, 269, 330, 332, 335, 362, 363, 369, 375, 379, 541, 542, 582, 585, 586, 594] });
                        break;
                      default:
                        this.setState({ ratioType: rad.target.value, ratioEvents: [] });
                        break;
                    }
                    console.log("set prop", this.state.ratioEvents);
                  }}
                  selectedValue={this.state.ratioType}
                >
                  <Radio label={<Trans>entries</Trans>} value="0" />
                  <Radio label={<Trans>exits</Trans>} value="1" />
                  <Radio label={<Trans>a custom selection of events</Trans>} value="2" />
                </RadioGroup>
                <EventSelect value={this.state.ratioEvents} onSelectionChange={(selection) => this.setState({ ratioEvents: selection })} />
              </div>
              : null}

          </div>
          <div className={Classes.DIALOG_FOOTER}>
            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
              <Button
                icon='undo'
                intent={Intent.DANGER}
                onClick={() => this.props.onClose()}
              >
                <Trans>cancel</Trans>
              </Button>
              <Button icon='trash'
                onClick={() => {
                  authenticatedDeleteFetch('/keyvalue',
                    { id: this.state.id },
                    (code, authResponse) => {
                      if (code === 200) {
                        this.props.onUpdate();
                        this.setState({ success: true })
                      }
                      else {
                        this.setState({ error: true });
                        this.props.onClose();
                      }
                    }, () => { this.setState({ error: true }); this.props.onClose() });
                }}
              >
                <Trans>delete</Trans>
              </Button>
              <Button icon='send-to'
                onClick={() => {
                  authenticatedPutFetch('/keyvalue',
                    { id: this.state.id, title: this.state.title, events: this.state.events, level: this.state.level, ratioEvents: this.state.ratioEvents },
                    (code, authResponse) => {
                      if (code === 200) {
                        this.props.onUpdate();
                        this.setState({ success: true })
                      }
                      else {
                        this.setState({ error: true });
                        this.props.onClose();
                      }
                    }, () => { this.setState({ error: true }); this.props.onClose() });
                }}
              >
                <Trans>send</Trans>
              </Button>
            </div>
          </div>
        </Dialog>
        <Alert
          isOpen={this.state.success}
          onClose={() => this.setState({ success: false })}
          onConfirm={() => this.setState({ success: false })}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          intent="success"
          icon="tick"
        >
          <Trans>edited successfully</Trans>
        </Alert>
        <Alert
          isOpen={this.state.error}
          onClose={() => this.setState({ error: false })}
          onConfirm={() => this.setState({ error: false })}
          canEscapeKeyCancel={true}
          canOutsideClickCancel={true}
          intent="danger"
          icon="error"
        >
          <Trans>error while editing</Trans>
        </Alert>
      </div >);
  }
}